// Яндекс.Метрика — инициализируется ТОЛЬКО если задан VITE_YANDEX_METRIKA_ID.
// ID хранится в .env.prod (VITE_YANDEX_METRIKA_ID=110389769), т.е. счётчик активен
// только на PROD (natcat.ru). На DEV и при доступе по IP переменная пустая →
// счётчик не грузится (нет шума в статистике).
//
// Используется официальный инициализатор Метрики (tag.js с ?id=<id>), встраиваемый
// программно, чтобы не держать инлайн-скрипт в index.html и не грузить вне PROD.

const METRIKA_ID = import.meta.env.VITE_YANDEX_METRIKA_ID;

/**
 * Подключить Яндекс.Метрику. Безопасно вызывать всегда: если ID не задан —
 * функция ничего не делает.
 */
export function initYandexMetrika() {
  const id = String(METRIKA_ID ?? '').trim();
  if (!id) return; // нет ID (DEV / IP-доступ) — счётчик не подключаем

  const numericId = Number(id);
  const tagSrc = `https://mc.yandex.ru/metrika/tag.js?id=${id}`;

  // Официальный загрузчик tag.js (сниппет Метрики), с ?id=<id> в URL скрипта.
  /* eslint-disable */
  (function (m, e, t, r, i, k, a) {
    m[i] = m[i] || function () { (m[i].a = m[i].a || []).push(arguments); };
    m[i].l = 1 * new Date();
    for (let j = 0; j < e.scripts.length; j++) { if (e.scripts[j].src === r) { return; } }
    k = e.createElement(t); a = e.getElementsByTagName(t)[0];
    k.async = 1; k.src = r; a.parentNode.insertBefore(k, a);
  })(window, document, 'script', tagSrc, 'ym');
  /* eslint-enable */

  window.ym(numericId, 'init', {
    webvisor: true,
    clickmap: true,
    accurateTrackBounce: true,
    trackLinks: true,
  });

  // <noscript>-пиксель (для клиентов без JS) — добавляем только при заданном ID.
  const ns = document.createElement('noscript');
  ns.innerHTML =
    `<div><img src="https://mc.yandex.ru/watch/${id}" ` +
    `style="position:absolute; left:-9999px;" alt="" /></div>`;
  document.body.appendChild(ns);
}
